import { PortalValidatorFn } from '@portal/form/data-access';
import { ValidationErrors } from '@angular/forms';
import { APPLICATION_ID } from '@core/data-access';

export const applicationIdValidator: PortalValidatorFn<ValidationErrors | null> = (control, field, options) => {
  const appId = control.getRawValue();

  if (typeof appId !== 'string') return null;

  if (APPLICATION_ID.PATTERN.test(appId) && appId.length <= APPLICATION_ID.MAX_LENGTH) {
    return null;
  }

  return { 'application-id': true };
};
